
import React from 'react';
import { Title } from '@vds/typography';

class SideBanner extends React.PureComponent {
    render() {       
        return (
            <div className="column padding-vert-zero loop-qualification_left LQR_hide loop-qual-hide-mobile medium-4">
                <div className="tiny-p-100 medium-p-100 padding-vert-small" >
                    {/*<h1 id="side-banner-text" className="text-white margin-horiz-zero text-left padding-left-medium lq_h3-change-h1">
                        {this.props.bannerText}
        </h1>*/}
                    <Title size="large" viewport="desktop" primitive="h1" color="white">
                        {this.props.bannerText}
                        </Title>
                </div>
            </div>
        );
    }
}

export default SideBanner;